import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
export function CanonicalInternalLinks() {
  const navigate = useNavigate();
  useEffect(() => {
    const normalizeLink = (anchor: HTMLAnchorElement) => {
      const url = new URL(anchor.href);
      if (url.origin !== window.location.origin || isCanonicalPath(url.pathname)) return;
      url.pathname = toEnglishPath(url.pathname);
      anchor.href = url.toString();
      anchor.dataset.canonicalInternal = 'true';
    };
    const normalizeLinks = (root: ParentNode = document) => {
      root.querySelectorAll<HTMLAnchorElement>('a[href]').forEach(normalizeLink);
    };
    const handleClick = (event: MouseEvent) => {
      if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
        return;
      }
      const target = event.target;
      if (!(target instanceof Element)) return;
      const anchor = target.closest<HTMLAnchorElement>('a[href]');
      if (!anchor || anchor.target === '_blank' || anchor.hasAttribute('download')) return;
      const url = new URL(anchor.href);
      const wasNormalized = anchor.dataset.canonicalInternal === 'true';
      if (url.origin !== window.location.origin || !wasNormalized && isCanonicalPath(url.pathname)) return;
      event.preventDefault();
      navigate(`${toEnglishPath(url.pathname)}${url.search}${url.hash}`);
    };
    normalizeLinks();
    document.addEventListener('click', handleClick, true);
    const observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        if (mutation.type === 'attributes' && mutation.target instanceof HTMLAnchorElement) {
          normalizeLink(mutation.target);
          return;
        }
        mutation.addedNodes.forEach(node => {
          if (!(node instanceof Element)) return;
          if (node instanceof HTMLAnchorElement) normalizeLink(node);
          normalizeLinks(node);
        });
      });
    });
    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ['href'],
      childList: true,
      subtree: true
    });
    return () => {
      observer.disconnect();
      document.removeEventListener('click', handleClick, true);
    };
  }, [navigate]);
  return null;
}
function isCanonicalPath(pathname: string) {
  return pathname === '/en' || pathname.startsWith('/en/') || pathname === '/ar' || pathname.startsWith('/ar/');
}
function toEnglishPath(pathname: string) {
  return isCanonicalPath(pathname) ? pathname : `/en${pathname}`;
}